module.exports = __webpack_public_path__ + "img/heading-icon.9aa772ee.svg";